import { MapContainer, TileLayer, Marker, Popup, LayersControl } from 'react-leaflet';
import { useEffect, useState, useRef } from 'react';
import axios from '../../config/axiosInstance';
import { useNavigate } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
// import 'esri-leaflet';
import 'esri-leaflet/dist/esri-leaflet.js'
import API_BASE_URL from '../../config/api';

// แก้ปัญหา marker icon ไม่แสดง
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default function MapsScreen() {
    const navigate = useNavigate();
    const [temples, setTemples] = useState([]);
    const mapDiv = useRef(null);

    useEffect(() => {
        axios.get('/api/get-temples') // ปรับตาม endpoint จริงของคุณ
            .then((res) => {
                //console.log('temples', res.data.temples);
                setTemples(res.data.temples);
            })
            .catch((err) => console.error(err));
    }, []);


    return (
        <>
            <MapContainer ref={mapDiv} center={[13.7563, 100.5018]} zoom={6} style={{ height: '90vh', width: '100%' }}>

                <LayersControl position="topright">
                    {/* ✅ OpenStreetMap Base Layer */}
                    <LayersControl.BaseLayer name="OpenStreetMap">
                        <TileLayer
                            attribution='© OpenStreetMap'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>

                    {/* ✅ Custom XYZ Tile Layer */}
                    <LayersControl.BaseLayer name="แผนที่ทางทหาร L7018">
                        <TileLayer
                            attribution="© Atomsoft Co.,Ltd"
                            url={`${API_BASE_URL}/tiles/{z}/{x}/{y}.png`} // Proxy จาก Node.js ที่คุณทำไว้
                        />
                    </LayersControl.BaseLayer>

                    {/* ✅ Google Map Tile Layer */}
                    <LayersControl.BaseLayer name="Google Map">
                        <TileLayer
                            attribution="© Google"
                            url={`https://mt1.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}`} // Proxy จาก Node.js ที่คุณทำไว้
                        />
                    </LayersControl.BaseLayer>

                    {/* ✅ Google Hybrid Tile Layer */}
                    <LayersControl.BaseLayer checked name="Google Map Hybrid">
                        <TileLayer
                            attribution="© Google"
                            url={`https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}`} // Proxy จาก Node.js ที่คุณทำไว้
                        />
                    </LayersControl.BaseLayer>

                    {/* ✅ Esry Satlite Tile Layer */}
                    <LayersControl.BaseLayer name="ภาพถ่ายดาวเทียม">
                        <TileLayer
                            attribution="© Google"
                            url={`https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}`} // Proxy จาก Node.js ที่คุณทำไว้
                        />
                    </LayersControl.BaseLayer>

                </LayersControl>

                <TileLayer
                    attribution='© Google'
                    url="https://mt1.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}"
                />

                {temples.map((temple) => (
                    <>

                        {temple.longitude && temple.longitude && (
                            <>
                                <Marker
                                    key={temple.id}
                                    position={[temple.latitude, temple.longitude]}
                                >
                                    <Popup>
                                        <strong>{temple.name}</strong><br />
                                        {temple.address} ต.{temple.subdistrict} อ.{temple.district} จ.{temple.province} {temple.postal_code}<br />
                                        <button
                                            onClick={() => navigate(`/temples/${temple.id}`)}
                                            style={{ marginTop: '5px', padding: '5px 10px' }}
                                        >
                                            แสดงรายละเอียด
                                        </button>
                                    </Popup>
                                </Marker>
                            </>
                        )}

                    </>

                ))}
            </MapContainer>
        </>
    );
}
